import { InputField } from '@xver/components/Atoms';
import DialogBox from '@xver/components/Atoms/DialogBox/DialogBox';
import { useTranslation } from 'react-i18next';

interface CredentialsCardProps {
    username: string;
    /** Undefined when the API withheld it (view-only access). */
    password?: string;
    ipAddress: string;
    isWindows: boolean;
}

export default function CredentialsCard({
    username,
    password,
    ipAddress,
    isWindows,
}: CredentialsCardProps) {
    const { t } = useTranslation('bareMetal');
    const sshCommand = !isWindows && username && ipAddress ? `ssh ${username}@${ipAddress}` : '';

    return (
        <DialogBox
            label={t('detail.credentials.title')}
            description={t(
                isWindows ? 'detail.credentials.descriptionRdp' : 'detail.credentials.description'
            )}
            classNames="p-4 gap-3"
        >
            <InputField
                size="md"
                label={t('detail.credentials.username')}
                value={username}
                readOnly
                showCopy
            />
            {password === undefined ? (
                <p className="text-sm text-fg/68">{t('projects:resource.passwordHidden')}</p>
            ) : (
                <InputField
                    size="md"
                    type="password"
                    label={t('detail.credentials.password')}
                    value={password}
                    readOnly
                    passwordReveal
                    showCopy
                />
            )}
            {sshCommand && (
                <InputField
                    size="md"
                    label={t('detail.credentials.sshCommand')}
                    value={sshCommand}
                    inputClassName="font-mono"
                    readOnly
                    showCopy
                />
            )}
        </DialogBox>
    );
}
